import React from 'react'
import { useState } from 'react'
import MyButton from '../../../../../UI/form/MyButton'
import MyModal from '../../../../../UI/modal/MyModal'
import WriteOffActItemForm from './WriteOffActItemForm'
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';

const WriteOffActItemButton = ({ writeOffActId, writeOffActItem }) => {

    const [open, setOpen] = useState(false)

  return (
    <>
        <MyButton
            size='smExtra'
            onClick={e => setOpen(true)}
        >
            {
                writeOffActItem ? <EditIcon /> : <AddIcon />
            }
        </MyButton>

        <MyModal
            open={open}
            setOpen={setOpen}
            header={writeOffActItem ? 'Редагувати позицію в акті' : 'Додати позицію в акт'}
            disableClickOutside={true}
            content={
                <WriteOffActItemForm
                    writeOffActId={writeOffActId}
                    writeOffActItemBd={writeOffActItem}
                    setOpen={setOpen}
                />
            }
        />
    </>
  )
}

export default WriteOffActItemButton